import { getApi } from '@sitemax/smx-components';
import { tokenRefresher } from '../utilities/tokenRefresher';
import { store } from '../store';

export const getAccessToken = async () => {
    const token = await tokenRefresher(store);

    return token || process.env.REACT_APP_API_TOKEN || '';
};

export const Api = getApi(getAccessToken);
